import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Alert, ListGroup, ListGroupItem } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Sponsors from '../store/Sponsors';
import * as utility from '../data/Utility';

class SelectSponsorInternal extends React.Component {
    constructor(props) {
        super(props);

        const accountId = utility.propCheck(props.accountId, "");
        const createStudy = utility.propCheck(props.createStudy, false);
        const linkToStudy = utility.propCheck(props.linkToStudy, false);
        const studyId = utility.propCheck(props.studyId, "");
        const studyName = utility.propCheck(props.studyName, "");
        this.state = {
            accountId: accountId,
            createStudy: createStudy,
            linkToStudy: linkToStudy,
            studyId: studyId,
            studyName: studyName
        };

        this.createListGroup = this.createListGroup.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    createListGroup(sponsors) {
        var linkPath = paths.selectStudy;
        if (this.state.linkToStudy) {
            if (this.state.createStudy) {
                linkPath = paths.createStudy;
            }
            else {
                linkPath = paths.study;
            }
        }

        const listItems = sponsors.map(sponsor => {
            return (
                <ListGroupItem key={sponsor.id} tag={Link} to={{ pathname: linkPath, state: { create: this.state.createStudy, sponsor: sponsor, studyId: this.state.studyId } }} title={sponsor.name} action>
                    {sponsor.name}
                </ListGroupItem>
            );
        });
        return (
            <ListGroup>
                {listItems}
            </ListGroup>
        );
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching)) {
            this.props.sponsorsDispatch.getAll();
        }
    }

    render() {
        if (!Accounts.authenticatedAllRoles(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var sponsorList = null;

        const sponsors = this.props.sponsorsState.all;
        if (sponsors != null &&
            sponsors.length != null &&
            sponsors.map != null) {
            sponsorList = this.createListGroup(sponsors);
            if (sponsors.length <= 0) {
                message = "There are not any sponsors in the system.";
            }
        }
        else {
            error = true;
            message = "Error retrieving sponsors.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        var studyName = this.state.studyName;
        if (studyName === "") {
            studyName = "{empty}";
        }

        var header = (<h1>Sponsors:</h1>);
        if (this.state.linkToStudy) {
            header = (
                <div>
                    <h1>Link Sponsor</h1>
                    <h3>to study name '{studyName}'</h3>
                </div>
            );
        }

        return (
            <div>
                {header}
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {sponsorList}
            </div>
        );
    }
}

const SelectSponsorConnect = connect(
    state => ({
        accountsState: state.accounts,
        sponsorsState: state.sponsors
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sponsorsDispatch: bindActionCreators(Sponsors.actionCreators, dispatch)
    })
)(SelectSponsorInternal);

export default class SelectSponsor extends React.Component {
    render() {
        var accountId = "";
        var createStudy = false;
        var linkToStudy = false;
        var studyId = "";
        var studyName = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            accountId = utility.propCheck(propsState.accountId, accountId);
            createStudy = utility.propCheck(propsState.createStudy, createStudy);
            linkToStudy = utility.propCheck(propsState.linkToStudy, linkToStudy);
            studyId = utility.propCheck(propsState.studyId, studyId);
            studyName = utility.propCheck(propsState.studyName, studyName);
        }

        return (
            <ErrorBoundary>
                <SelectSponsorConnect accountId={accountId} createStudy={createStudy} linkToStudy={linkToStudy} studyId={studyId} studyName={studyName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectSponsor.js